/* Geo Gear Co: small glass previews in the cart page and cart drawer.
   Finds the "Glass N: Design X · ... – Name · Font: F" property lines under each cart item and adds a row of
   thumbnails after them (drawn by assets/ggc-glass-render.js, loaded only when needed). */
(function(){
  if(window.GGCGlassCart) return; window.GGCGlassCart=true;
  var RE=/^ *Glass *([0-9]+) *: *Design *([0-9]+)/i, loading=false, pend=null;
  var WS=new RegExp('['+String.fromCharCode(9,10,13,160)+' ]+','g');
  function flat(el){ return (el.textContent||'').replace(WS,' ').trim(); }
  /* innermost elements whose text starts with "Glass N: Design X" (found from their text nodes, so it stays cheap) */
  function lines(){
    var out=[], tw=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT), nd;
    while((nd=tw.nextNode())){
      var v=nd.nodeValue; if(v.indexOf('Design')<0&&v.indexOf('Glass')<0) continue;
      var el=nd.parentElement, k=0, hit=null;
      while(el&&k<3){
        if(el.closest('.ggc-gl,.ggc-proof,.ggc-glc,script,style,noscript,textarea')) break;
        var t=flat(el); if(t.length>400) break;
        if(RE.test(t)){ hit=el; break; }
        el=el.parentElement; k++;
      }
      if(hit&&out.indexOf(hit)<0) out.push(hit);
    }
    return out;
  }
  function textOf(el){
    var parts=[], tw=document.createTreeWalker(el,NodeFilter.SHOW_TEXT), nd;
    while((nd=tw.nextNode())){ var v=nd.nodeValue.replace(WS,' ').trim(); if(v) parts.push(v); }
    /* "Glass 1:" and "Design 7 ..." may be separate text nodes; rejoin a lone "Glass N:" with the next part */
    var out=[]; for(var i=0;i<parts.length;i++){ if(/^Glass *[0-9]+ *:?$/i.test(parts[i])&&parts[i+1]){ out.push(parts[i]+' '+parts[i+1]); i++; } else out.push(parts[i]); }
    return out.join(String.fromCharCode(10));
  }
  function group(els){
    var gs=[];
    els.forEach(function(el){
      var p=el.parentElement;
      /* lines of one item share a parent (or grandparent when each line is wrapped) */
      var g=null; for(var i=0;i<gs.length;i++){ if(gs[i].p===p||gs[i].p===(p&&p.parentElement)||gs[i].pp===p){ g=gs[i]; break; } }
      if(!g){ g={p:p,pp:p&&p.parentElement,els:[]}; gs.push(g); }
      g.els.push(el);
    });
    return gs;
  }
  function paint(){
    var G=window.GGCGlass; if(!G) return;
    group(lines()).forEach(function(g){
      var items=G.parse(g.els.map(textOf).join(String.fromCharCode(10)));
      if(!items.length) return;
      var last=g.els[g.els.length-1], key=items.map(function(it){ return it.d+'|'+it.name+'|'+it.font; }).join('/');
      var strip=last.nextElementSibling&&last.nextElementSibling.classList.contains('ggc-glc')?last.nextElementSibling:null;
      if(strip&&strip.getAttribute('data-k')===key&&strip.getAttribute('data-r')===(G.ready()?'1':'0')) return;
      if(!strip){ strip=document.createElement('div'); strip.className='ggc-glc'; last.parentNode.insertBefore(strip,last.nextSibling); }
      strip.setAttribute('data-k',key); strip.setAttribute('data-r',G.ready()?'1':'0'); strip.innerHTML='';
      items.forEach(function(it){
        var f=document.createElement('span'); f.className='ggc-glc__g'; f.title='Glass '+it.g+': '+(it.name||'')+(G.fontLabel?' ('+G.fontLabel(it.font)+')':'');
        var c=document.createElement('canvas'); c.width=160; c.height=128; G.draw(c,it.d,it.name,it.font);
        var n=document.createElement('i'); n.textContent=String(it.g);
        f.appendChild(c); f.appendChild(n); strip.appendChild(f);
      });
    });
  }
  function run(){
    pend=null;
    if(!lines().length) return;
    if(window.GGCGlass){ window.GGCGlass.init(); paint(); return; }
    if(loading) return; loading=true;
    var sc=document.createElement('script'); sc.src=window.GGC_GLASS_JS; sc.async=true;
    sc.onload=function(){ var G=window.GGCGlass; if(!G) return; G.init(); G.onChange(function(){ document.querySelectorAll('.ggc-glc').forEach(function(s){ s.setAttribute('data-r','x'); }); paint(); }); paint(); };
    document.head.appendChild(sc);
  }
  function soon(){ if(pend) return; pend=setTimeout(run,250); }
  var css=document.createElement('style');
  css.textContent='.ggc-glc{display:flex;flex-wrap:wrap;gap:4px;margin:6px 0 4px}.ggc-glc__g{position:relative;display:block;width:52px;border:1px solid #e3d6c1;border-radius:6px;background:#fff;overflow:hidden}.ggc-glc__g canvas{display:block;width:100%;height:auto}.ggc-glc__g i{position:absolute;left:2px;top:2px;min-width:13px;height:13px;padding:0 2px;border-radius:7px;background:#16201f;color:#fff;font:700 9px/13px sans-serif;text-align:center;font-style:normal}';
  document.head.appendChild(css);
  run();
  if('MutationObserver' in window) new MutationObserver(function(ms){
    for(var i=0;i<ms.length;i++){ var t=ms[i].target; if(t&&t.closest&&t.closest('.ggc-glc,.ggc-gl,.ggc-proof')) continue; soon(); return; }
  }).observe(document.body,{childList:true,subtree:true});
})();
